module.exports = __webpack_public_path__ + "img/nav-logo2.d7129236.svg";